import React from "react";
import { Star } from "lucide-react";

export default function StarRating({ value = 0, size = 14, showNumber = false }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className="inline-flex items-center gap-0.5">
      {stars.map((s) => {
        const filled = value >= s;
        const half = !filled && value >= s - 0.5;
        return (
          <span key={s} className="relative" style={{ width: size, height: size }}>
            <Star size={size} className="text-gray-300" fill="currentColor" strokeWidth={0} />
            {(filled || half) && (
              <span
                className="absolute inset-0 overflow-hidden"
                style={{ width: filled ? "100%" : "50%" }}
              >
                <Star size={size} className="text-[#f5a623]" fill="currentColor" strokeWidth={0} />
              </span>
            )}
          </span>
        );
      })}
      {showNumber && (
        <span className="ml-1.5 text-sm font-semibold text-gray-700">{value.toFixed(1)}</span>
      )}
    </div>
  );
}
